import styles from "./controls.module.css";
import { useEffect, useRef, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";

export function Controls({ isDisabled = false, onSend }) {
  const [content, setContent] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (!isDisabled) {
      textareaRef.current.focus();
    }
  }, [isDisabled]);

  function handlecontentchange(event) {
    setContent(event.target.value);
  }

  function handlecontentsend() {
    if (content.length > 0) {
      onSend(content);
      setContent("");
    }
  }
  function handleenterpress(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      console.log({ content });
      event.preventDefault();
      handlecontentsend();
    }
  }
  return (
    <div className={styles.controls}>
      <div className={styles.textareacontainer}>

        <TextareaAutosize
          ref={textareaRef}
          disabled={isDisabled}
          minRows={1}
          maxRows={4}
          onKeyDown={handleenterpress}
          className={styles.textarea}
          placeholder="Message AI Chatbot"
          onChange={handlecontentchange}
          value={content}
        /> 
      </div>
      <button
        disabled={isDisabled}
        className={styles.button}
        onClick={handlecontentsend}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="#1f1f1f"
        >
          <path d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z" />
        </svg>
      </button>
    </div>
  );
}


